import React from "react";
import DesktopImagePreview from "./DesktopImagePreview";
import MobileImagePreview from "./MobileImagePreview";

export default function ImagePreviewSection(props) {
    const [mobile,] = React.useState(window.innerWidth < 900);

    return (
        mobile ? <MobileImagePreview/> : <DesktopImagePreview/>
    );
}